module.exports = __webpack_public_path__ + "img/2.3472a5e.svg";